import axiosInstance from './axiosInstance';

export async function registerUser(payload) {
  const response = await axiosInstance.post('/auth/register', payload);
  return response.data; // { message }
}

export async function loginUser(payload) {
  const response = await axiosInstance.post('/auth/login', payload);
  return response.data; // { token, user: { id, email, role } }
}

export async function verifyEmail(token) {
  const response = await axiosInstance.get(`/auth/verify-email/${token}`);
  return response.data; // { message }
}

export async function resendVerification(email) {
  const response = await axiosInstance.post('/auth/resend-verification', { email });
  return response.data; // { message }
}

export async function forgotPassword(email) {
  const response = await axiosInstance.post('/auth/forgot-password', { email });
  return response.data;
}

export async function resetPassword(token, password, confirmPassword) {
  const response = await axiosInstance.post(`/auth/reset-password/${token}`, { password, confirmPassword });
  return response.data;
}